import { Details } from '../models/details.interfaces';

export const SilverMedallionBannerDetailsMocks: Details = {
  title: 'Good Morning, Rocky',
  action: {
    label: 'VIEW YOUR BENEFITS',
    url: '/us/en/skymiles/medallion-program/medallion-benefits'
  },
  milesData: {
    skyMiles: { title: 'SKYMILES #', subtitle: '8006270311' },
    miles: { title: 'MILES AVAILABLE', subtitle: '38,000' }
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'SILVER MEDALLION®',
    level: '0',
    name: 'silver'
  }
};

export const SilverMillionMilerMedallionBannerDetailsMocks: Details = {
  title: 'Good Morning, Rocky',
  action: {
    label: 'VIEW YOUR BENEFITS',
    url: '/us/en/skymiles/medallion-program/medallion-benefits'
  },
  milesData: {
    skyMiles: { title: 'SKYMILES #', subtitle: '8006270311' },
    miles: { title: 'MILES AVAILABLE', subtitle: '38,000' }
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'SILVER MEDALLION®',
    level: '1',
    name: 'silver'
  }
};

export const SilverMedallionBannerWithLifetimeDetailsMocks: Details = {
  title: 'Good Morning, Rocky',
  action: {
    label: 'VIEW YOUR BENEFITS',
    url: '/us/en/skymiles/medallion-program/medallion-benefits'
  },
  milesData: {
    skyMiles: { title: 'SKYMILES #', subtitle: '8006270311' },
    miles: { title: 'MILES AVAILABLE', subtitle: '38,000' }
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'SILVER MEDALLION®',
    level: '0',
    name: 'silver'
  }
};
